
import { Label } from "@/components/ui/label";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface CategorySelectProps {
  categoria: string;
  setCategoria: (value: string) => void;
  categorias: { categoria: string; itens: string[] }[] | { marca: string; modelos: string[] }[];
  label?: string;
  placeholder?: string;
}

export const CategorySelect = ({ 
  categoria, 
  setCategoria, 
  categorias,
  label = "Categoria",
  placeholder = "Selecione a categoria" 
}: CategorySelectProps) => {
  // Check if we're dealing with marca/modelos structure or categoria/itens
  const isMarcaModelos = categorias.length > 0 && 'marca' in categorias[0];

  return (
    <div className="grid gap-2">
      <Label htmlFor="categoria">{label}</Label>
      <Select
        value={categoria}
        onValueChange={setCategoria}
      >
        <SelectTrigger id="categoria">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {categorias.map((cat) => {
            // Handle both data structures
            const categoryName = isMarcaModelos 
              ? (cat as { marca: string }).marca 
              : (cat as { categoria: string }).categoria;
              
            return (
              <SelectItem key={categoryName} value={categoryName}>
                {categoryName}
              </SelectItem>
            );
          })}
          <SelectItem value="Outro">Outro / Personalizado</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
